import { useGetPaymentFees } from '@/apis/payments/hooks/useGetPaymentFees'
import MultiQueryPageLoader from '@/app/common/components/PageLoader/MultiQueryPageLoader'
import { useStudentPurses } from '@/app/pages/providers/api/usePaymentProviders'
import { selectFamilyApplication } from '@/storage/applications/familyApplicationSlice'
import { SelectedPurse } from '@/storage/applications/providerPaySlice'
import { selectProgramID } from '@/storage/program_settings/programSettingsSlice'
import { useSelector } from 'react-redux'
import SelectPursesForm from './_components/select_purses_form'

type Props = {
  onNext: (data: SelectedPurse[]) => void
  defaultValues: SelectedPurse[]
  amount: number
}

export const ReimbursementSelectPursesPage = (props: Props) => {
  const { onNext, defaultValues, amount} = props
  const programId = useSelector(selectProgramID)
  const application = useSelector(selectFamilyApplication)


  const studentPurseQuery = useStudentPurses({
    program_id: programId,
    application_id: application.application_id,
  })

  const paymentFeesQuery = useGetPaymentFees({
    base_amount: amount,
    program_id: programId,
  })



  return (
    <MultiQueryPageLoader
    queries={[studentPurseQuery, paymentFeesQuery] as const}
    >
      {([purses, paymentFees]) => {
        return (
          <SelectPursesForm fees={paymentFees}  amount={amount} defaultValues={defaultValues} onNext={onNext} apiPurses={purses} />
        )
      }}
    </MultiQueryPageLoader>

  )
}
